/*
 * @Author: huangshimin@klcxkj.com
 * @Date: 2022-03-28 16:46:52
 * @LastEditors: huangshimin@klcxkj.com
 * @LastEditTime: 2022-08-03 19:46:35
 * @FilePath: \app-client-h5\src\pages\bindRoom\index.jsx
 */

import React, { Component } from 'react';
import {
    Form,
    Input,
    Button,
    Dialog,
    Ellipsis,
    CascaderView,
    CheckList,
    Popup,
    Toast,
} from 'antd-mobile';
import { bindRoom,projectSelect,roomSelect } from "./services.js";
import {handleToast,getQueryVariable,host} from "../../utils/util";
import _ from 'lodash'

import './index.scss';
const style_title={
    color:'#333333',
    fontSize:'0.30rem',
    textAlign:'center',
    height:'1rem',
    lineHeight:'1rem',
    borderBottom:'0.01rem solid #EEEEEE'
}
const scroll_box = {
    height: '6rem',
    minHeight:'4rem',
    overflowY: 'scroll',
    padding:'0 0.24rem',
    fontSize:'0.26rem',
}
const scroll_item = {
    height:'1rem',
    borderBottom: '0.01rem solid #DFDFDF',
    lineHeight:'1rem',
    color:'#333333',
    fontSize:'0.28rem',
    whiteSpace:'nowrap',
    overflow:'hidden',
    textOverflow:'ellipsis'
}
const colorhover = {
    color: '#4292FF'
}
class BindRoom extends Component {
    formRef = React.createRef();
    constructor(props) {
        super(props)
        this.state = {
            arrow:require('../../assets/arrow.png'),
            showTip:false,
            RoomPopupVisible: false,
            projectPopupVisible: false,
            projectSelectArr:[],
            options: [
                
            ],
            currentItem:'',
            currentItemId:'',
            currentRoomId:'',
            valueCas:[]
        }
    }

    projectSelect = ()=>{
        projectSelect().then((res) =>{
            if (res.code == '200') {
                this.setState({
                    projectSelectArr:res.data
                })
            }else{
                Toast.show({
                    content: res.message,
                })
            }
        }).catch((err) =>{
            Toast.show({
                content: '系统错误',
            })
        })
    }

    roomSelect = (areaId = '',buildingId='',floorId='')=>{
        const {currentItemId,options} = this.state;
        const params = {
            projectId:currentItemId,
        }
        if (areaId) {
            params.areaId = areaId
        }
        if (buildingId) {
            params.buildingId = buildingId
        }
        if (floorId) {
            params.floorId = floorId
        }
        
        roomSelect(params).then((res) =>{
            
            if (res.code == '200') {
                if (areaId== ''&&buildingId==''&&floorId=='') {
                    if (res.data.length == 0) {
                        handleToast('该项目未添加区域')
                        this.setState({
                            RoomPopupVisible: false
                        })
                        return;
                    }
                    res.data.forEach((v,i)=>{
                        v.label = v.areaName;
                        v.value = v.areaId;
                        v.children = [];
                    })
                    this.setState({
                        options:res.data
                    })
                }else if(areaId!= ''&&buildingId==''&&floorId==''){
                    if (res.data.length == 0) {
                        handleToast('该区域未添加楼栋')
                        return;
                    }
                    res.data.forEach((v,i)=>{
                        v.label = v.buildingName;
                        v.value = v.buildingId;
                        v.children = [];
                    })
                    let obj = _.cloneDeep(options);
                    let aid = res.data[0].areaId;
                    obj.forEach((v,i)=>{
                        if (v.areaId == aid) {
                            v.children=res.data;
                        }
                    })
                    this.setState({
                        options:obj
                    })
                }else if(areaId!= ''&&buildingId!=''&&floorId==''){
                    if (res.data.length == 0) {
                        handleToast('该楼栋未添加楼层')
                        return;
                    }
                    res.data.forEach((v,i)=>{
                        v.label = v.floorName;
                        v.value = v.floorId;
                        v.children = [];
                    })
                    let obj = _.cloneDeep(options);
                    let aid = res.data[0].areaId;
                    let bid = res.data[0].buildingId;
                    obj.forEach((v,i)=>{
                        if (v.areaId == aid) {
                            v.children.forEach((e,k)=>{
                                if (e.buildingId == bid) {
                                    e.children = res.data;
                                }
                                
                            })
                        }
                    })

                    this.setState({
                        options:obj
                    })
                }else if(areaId!= ''&&buildingId!=''&&floorId!=''){
                    if (res.data.length == 0) {
                        handleToast('该楼层未添加房间')
                        return;
                    }
                    res.data.forEach((v,i)=>{
                        v.label = v.roomName;
                        v.value = v.roomId;
                    })
                    let obj = _.cloneDeep(options);
                    let aid = res.data[0].areaId;
                    let bid = res.data[0].buildingId;
                    let fid = res.data[0].floorId;
                    obj.forEach((v,i)=>{
                        if (v.areaId == aid) {
                            v.children.forEach((e,k)=>{
                                if (e.buildingId == bid) {
                                    e.children.forEach((z,s)=>{
                                        z.children = res.data;
                                    })
                                }
                                
                            })
                        }
                    })
                    this.setState({
                        options:obj
                    })
                }
                
            }else{
                Toast.show({
                    content: res.message,
                })
            }
        }).catch((err) =>{
            Toast.show({
                content: '系统错误',
            })
        })
    }
    componentWillMount(){
        this.projectSelect();
    }
    componentDidMount() {
        if (getQueryVariable('formPage') == 'my') {
            
            let roomData = JSON.parse(localStorage.getItem('roomData'));
            if (roomData) {
                this.setState({showTip:true,
                    currentItemId:roomData.projectId,
                    currentRoomId:roomData.roomId
                })
                this.formRef.current.setFieldsValue({
                    'room':roomData.room,
                    'project':roomData.projectName
                })
            }
            
            document.title = '修改绑定房间'
        }else{
            document.title = '绑定房间'
        }
        
    }
    onFinish = () => {
        const {currentItemId,currentRoomId} = this.state;
        const params = {
            roomId:currentRoomId,
            projectId:currentItemId,
        }
        bindRoom(params).then((res) =>{
            if (res.code == '200') {
                Toast.show({
                    content: '绑定成功',
                })
                setTimeout(()=>{
                    // window.location.replace(host+'home')
                    this.props.history.goBack()
                },600)
            }else{
                Toast.show({
                    content: res.message,
                })
            }
        }).catch((err) =>{
            Toast.show({
                content: '系统错误',
            })
        })
        
    }
    handleSelectRoom = () => {
        const {currentItemId,options} = this.state;
        if (!currentItemId) {
            Toast.show({
                content: '请先选择项目',
            })
            return;
        }
        this.setState({ RoomPopupVisible: true })
        if (options.length==0) {
            this.roomSelect()
        }
        
    }
    handleSelectRoomChange = (val,extend)=>{
        if (val.length == 1) {
            this.roomSelect(val[0])
        }
        if (val.length == 2) {
            this.roomSelect(val[0],val[1])
        }
        if (val.length == 3) {
            this.roomSelect(val[0],val[1],val[2])
        }
        
        if (val.length==4) {
            this.setState({ RoomPopupVisible: false })
            let room = extend[0].areaName+'-'+extend[1].buildingName+'-'+extend[2].floorName+'-'+extend[3].roomName;
            this.formRef.current.setFieldsValue({
                'room':room
            })
            this.setState({
                currentRoomId:val[3]
            })
        }
        console.log('onChange', val)
    }

    renderRoomPopup() {
        return (
            <Popup
                visible={this.state.RoomPopupVisible}
                onMaskClick={() => {
                    this.setState({ RoomPopupVisible: false })
                }}
            >
                <CascaderView 
                    style={{ '--height': '6rem' }}
                    options={this.state.options}
                    value={this.state.valueCas}
                    onChange={(val, extend) => {
                        this.setState({valueCas: val})
                        console.log('onChange', val, extend.items)
                        this.handleSelectRoomChange(val,extend.items)
                    }}
                />
            </Popup>
        )
    }
    renderProjectPopup(){
        const {projectSelectArr,currentItemIndex,currentItem,currentItemId,projectId} = this.state;
        return(
            <Popup
                visible={this.state.projectPopupVisible}
                onMaskClick={() => {
                    this.setState({ projectPopupVisible: false })
                }}
            >
                <div  style={style_title}>选择项目</div>
                <div style={scroll_box}>
                    {
                        projectSelectArr.map((item,i) =>{
                            return(
                                <div 
                                    onClick = {() =>{
                                        if (item.projectId!=projectId) {
                                            this.formRef.current.setFieldsValue({
                                                'room':''
                                            })
                                            this.setState({
                                                room:'',
                                                options:[]
                                            })
                                        }
                                        this.setState({
                                            currentItemIndex:i,
                                            projectPopupVisible: false,
                                            currentItem:item.projectName ,
                                            currentItemId:item.projectId
                                        })
                                        this.formRef.current.setFieldsValue({
                                            'project':item.projectName
                                        })
                                    }} 
                                    key={item.projectId} 
                                    style={ currentItemIndex === i ? {...scroll_item,...colorhover} : scroll_item}
                                    >
                                    {item.projectName}
                                </div>
                            )
                        })
                    }
                </div>
            </Popup>
        )
        
    }
    render() {
        const {arrow,showTip} = this.state;
        return (
            <div className="bindRoom-container">
                {this.renderRoomPopup()}
                {this.renderProjectPopup()}
                <Form
                    ref={this.formRef}
                    onFinish = {this.onFinish}
                    footer={
                        <Button block shape='rounded' type='submit' color='' className = 'bindRoom-submit'>
                            提交
                        </Button>
                    }
                    initialValues={{
                        project: '',
                        room: '',
                    }}
                >
                    <div
                        onClick={() => {
                            this.setState({ projectPopupVisible: true })
                        }}
                        className = 'arrow-box topb'
                    >
                        <Form.Item name='project' label='选择项目' rules={[{ required: true,message:'请选择项目' }]} >
                            <Input
                                placeholder='请选择'
                                readOnly
                            />
                            
                        </Form.Item>
                        <img className = 'arrow' src={arrow} />
                    </div>
                    <div
                        onClick={this.handleSelectRoom}
                        className = 'arrow-box'
                    >
                        <Form.Item name='room' label='选择房间' rules={[{ required: true ,message:'请选择房间'}]}>
                            <Input placeholder='请选择' readOnly />
                        </Form.Item>
                        <img className = 'arrow' src={arrow} />
                    </div>
                    {showTip&&<div className = 'tip'>注意：您购买的水量是和房间绑定的，请谨慎修改！</div>}
                </Form>
            </div>
        )
    }
}
export default BindRoom;

